module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-layout/gatsby-browser.js'),
      options: {"plugins":[],"component":"/builds/warsteiner/warsteiner-headless/warsteiner-frontend/src/components/common/Layout/Layout.js"},
    },{
      plugin: require('../node_modules/gatsby-plugin-graphql-preview/gatsby-browser.js'),
      options: {"plugins":[],"fieldName":"craft","typeName":"Craft","url":"https://cms.warsteiner.de/api","headers":{"Authorization":"bearer n0Qw12B-oEKG8U_LPAhMGAfQNxJUpBVbxhpsy8c3RMzKFJe9ewNgpZCpsvvMa5BM"}},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
